<app-confirm-dialog caption="Wijzigingen zijn niet opgeslagen" action="Stoppen met bewerken" secondaryAction="Annuleren">
	Weet je zeker dat je wilt stoppen met bewerken van deze pagina? Wijzigingen worden niet opgeslagen.
</app-confirm-dialog>
